(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessory-compatibility-finder"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = section => {
    if (section.dataset.afReady) return;
    section.dataset.afReady = 'true';
    const categories = [...section.querySelectorAll('[data-af-category]')];
    const pickers = [...section.querySelectorAll('[data-af-model-select]')];
    const selector = section.querySelector('.af-selector');
    const mobileModel = section.querySelector('[data-af-mobile-model]');
    const openSelectorButton = section.querySelector('[data-af-open-selector]');
    const modelDialog = section.querySelector('[data-af-model-dialog]');
    const mobileViewport = window.matchMedia('(max-width: 599px)');
    const resetDialogState = () => {openSelectorButton.setAttribute('aria-expanded','false');document.documentElement.classList.remove('af-model-dialog-open');};
    const closeSelector = () => {if (modelDialog.open) modelDialog.close();resetDialogState();};
    const syncSelectorPosition = () => {
      if (mobileViewport.matches) section.querySelector('[data-af-dialog-body]').append(selector);
      else {closeSelector();mobileModel.after(selector);}
    };
    const openSelector = () => {
      if (!mobileViewport.matches || modelDialog.open) return;
      modelDialog.showModal();openSelectorButton.setAttribute('aria-expanded','true');document.documentElement.classList.add('af-model-dialog-open');
      (pickers.find(picker => picker.value) || pickers[0])?.focus({preventScroll:true});
    };
    openSelectorButton.addEventListener('click',openSelector);
    section.querySelector('[data-af-close-selector]').addEventListener('click',closeSelector);
    modelDialog.addEventListener('close',() => {if (!modelDialog.open) resetDialogState();});
    modelDialog.addEventListener('cancel',resetDialogState);
    modelDialog.addEventListener('click',event => {if (event.target !== modelDialog) return;const rect = modelDialog.getBoundingClientRect();if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeSelector();});
    mobileViewport.addEventListener('change',syncSelectorPosition);
    syncSelectorPosition();
    const cards = [...section.querySelectorAll('[data-accessory-card]')];
    const typeGroup = section.querySelector('[data-af-types]');
    let catalog = [];
    try {catalog = JSON.parse(section.querySelector('[data-af-model-catalog]')?.textContent || '[]');} catch {}
    const modelReferences = new Map((Array.isArray(catalog) ? catalog : []).map(record => {
      const id = String(record.id || '');
      return [record.key,id && !id.startsWith('gid://') ? 'gid://shopify/Metaobject/' + id : id];
    }));
    const compatibility = new Map(cards.map(card => {
      try {const ids = JSON.parse(card.dataset.compatibleModelIds || '[]');return [card,Array.isArray(ids) ? ids : []];}
      catch {return [card,[]];}
    }));
    const variantControls = new Map(cards.map(card => {
      const picker = card.querySelector('[data-af-variant-select]');
      const options = [...picker.options];
      const references = new Map(options.map(option => {
        try {const ids = JSON.parse(option.dataset.compatibleModelIds || '[]');return [option,Array.isArray(ids) ? ids : []];}
        catch {return [option,[]];}
      }));
      return [card,{picker,options,references,button:card.querySelector('[data-af-add]'),price:card.querySelector('[data-af-price]')}];
    }));
    let model = '', modelReference = '', activeType = 'all', currentPicker = null;
    const eligibleOptions = card => {const control = variantControls.get(card);return control.options.filter(option => control.references.get(option).includes(modelReference));};
    const matchesModel = card => Boolean(modelReference) && compatibility.get(card).includes(modelReference) && eligibleOptions(card).length > 0;
    const updateVariant = card => {
      const control = variantControls.get(card), option = control.picker.selectedOptions[0];
      const compatible = Boolean(modelReference) && option && control.references.get(option).includes(modelReference);
      const available = compatible && option.dataset.available === 'true';
      control.button.disabled = !available;
      control.button.textContent = available ? card.dataset.addLabel : card.dataset.soldOutLabel;
      control.price.textContent = compatible ? option.dataset.price : '';
    };
    const updateVariants = () => cards.forEach(card => {
      const control = variantControls.get(card), eligible = eligibleOptions(card);
      const previousValue = control.picker.value;
      control.picker.replaceChildren(...eligible);
      control.picker.value = (eligible.find(option => option.value === previousValue) || eligible.find(option => option.dataset.available === 'true') || eligible[0])?.value || '';
      updateVariant(card);
    });
    variantControls.forEach((control,card) => {
      control.picker.addEventListener('change',() => updateVariant(card));
      card.querySelector('form').addEventListener('submit',event => {
        updateVariant(card);
        if (!matchesModel(card) || control.button.disabled) event.preventDefault();
      });
    });
    const updateResults = () => {
      let visible = 0;
      cards.forEach(card => {card.hidden = !(model && matchesModel(card) && (activeType === 'all' || card.dataset.cardType === activeType));if (!card.hidden) visible++;});
      section.querySelector('[data-accessory-prompt]').hidden = Boolean(model);
      section.querySelector('[data-af-selection]').hidden = !model;
      section.querySelector('[data-af-results-head]').hidden = !model;
      section.querySelector('[data-accessory-empty]').hidden = !model || visible > 0;
      section.querySelector('[data-accessory-toolbar]').hidden = !model || !cards.some(matchesModel);
      section.querySelector('[data-af-clear-filter]').hidden = activeType === 'all';
      section.querySelector('[data-accessory-count]').textContent = visible + ' ' + (visible === 1 ? section.dataset.countSingular : section.dataset.countPlural);
    };
    const buildTypes = () => {
      activeType = 'all';typeGroup.replaceChildren();
      const types = new Map([['all',section.dataset.allTypes]]);
      cards.filter(matchesModel).forEach(card => types.set(card.dataset.cardType,card.dataset.cardTypeLabel));
      types.forEach((label,key) => {const button = document.createElement('button');button.type = 'button';button.className = 'accessory-finder__type' + (key === 'all' ? ' is-active' : '');button.dataset.accessoryType = key;button.setAttribute('aria-pressed',String(key === 'all'));button.textContent = label;typeGroup.append(button);});
    };
    const selectModel = picker => {
      model = picker.value;currentPicker = model ? picker : null;
      modelReference = modelReferences.get(model) || '';
      pickers.forEach(item => {if (item !== picker) item.value = '';});
      categories.forEach(card => card.classList.toggle('is-active',Boolean(model) && card.dataset.afCategory === picker.dataset.category));
      const name = picker.selectedOptions[0]?.textContent || '';
      section.querySelector('[data-af-selected-name]').textContent = model ? name : '';
      section.querySelector('[data-af-mobile-model-name]').textContent = model ? name : openSelectorButton.dataset.selectLabel;
      openSelectorButton.setAttribute('aria-label',model ? openSelectorButton.dataset.changeLabel + ': ' + name : openSelectorButton.dataset.selectLabel);
      section.querySelector('[data-af-results-title]').textContent = section.dataset.resultHeading.replace('__MODEL__',name);
      updateVariants();buildTypes();updateResults();
      if (model && modelDialog.open) closeSelector();
    };
    pickers.forEach(picker => picker.addEventListener('change',() => selectModel(picker)));
    typeGroup.addEventListener('click',event => {const button = event.target.closest('[data-accessory-type]');if (!button) return;activeType = button.dataset.accessoryType;typeGroup.querySelectorAll('button').forEach(item => {const active = item === button;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',String(active));});updateResults();});
    section.querySelector('[data-af-clear-filter]').addEventListener('click',() => {buildTypes();updateResults();});
    section.querySelector('[data-af-change]').addEventListener('click',() => {if (mobileViewport.matches) openSelector();else {const picker = currentPicker || pickers[0];picker?.focus();}});
    const initial = pickers.find(picker => picker.value);
    if (initial) selectModel(initial);else {updateVariants();updateResults();}
  };
  const initAll = root => {if (root.matches?.('[data-accessory-finder]')) init(root);root.querySelectorAll('[data-accessory-finder]').forEach(init);};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initAll(document));else initAll(document);
  document.addEventListener('shopify:section:load',event => initAll(event.target));
  document.addEventListener('shopify:block:select',event => {const section = event.target.closest?.('[data-accessory-finder]');const picker = section?.querySelector('[data-af-model-select][data-category="' + event.detail.blockId + '"]');picker?.focus();});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const singaporeOffsetMs = 8 * 60 * 60 * 1000;

    const nextSingaporeMidnight = () => {
      const singaporeNow = new Date(Date.now() + singaporeOffsetMs);
      return Date.UTC(
        singaporeNow.getUTCFullYear(),
        singaporeNow.getUTCMonth(),
        singaporeNow.getUTCDate() + 1,
        0,
        0,
        0
      ) - singaporeOffsetMs;
    };

    const pad = (value) => String(value).padStart(2, '0');

    const initHero = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dailyMode = root.dataset.dailyMode === 'true';
      const configuredEnd = Number(root.dataset.endTimestamp) * 1000;
      let deadline = dailyMode ? nextSingaporeMidnight() : configuredEnd;
      if (!Number.isFinite(deadline) || deadline <= 0) deadline = Date.parse(root.dataset.endAt);
      if (!Number.isFinite(deadline)) deadline = nextSingaporeMidnight();

      const form = root.querySelector('.rr-flash-hero__form');
      const button = root.querySelector('[data-add-to-cart]');
      const mobileButton = root.querySelector('[data-mobile-buy]');
      const status = root.querySelector('[data-form-status]');

      const timerFields = {
        days: root.querySelector('[data-timer-days]'),
        hours: root.querySelector('[data-timer-hours]'),
        minutes: root.querySelector('[data-timer-minutes]'),
        seconds: root.querySelector('[data-timer-seconds]')
      };

      let timerInterval;

      const closeDrop = () => {
        const wasClosed = root.dataset.dropClosed === 'true';
        root.dataset.dropClosed = 'true';
        root.classList.add('rr-flash-hero--closed');
        root.querySelectorAll('[data-flash-live-only]').forEach((element) => {
          element.hidden = true;
        });
        root.querySelectorAll('[data-flash-closed-only]').forEach((element) => {
          element.hidden = false;
        });
        if (button) button.disabled = true;
        if (mobileButton) mobileButton.disabled = true;
        if (status) status.textContent = '';
        if (timerInterval) window.clearInterval(timerInterval);
        if (!wasClosed) document.dispatchEvent(new CustomEvent('flash-sale:closed'));
      };

      if (root.dataset.dropClosed === 'true') {
        closeDrop();
        return;
      }

      if (timerFields.seconds) {
        const updateTimer = () => {
          const distance = deadline - Date.now();
          if (distance <= 0) {
            timerFields.days.textContent = '00';
            timerFields.hours.textContent = '00';
            timerFields.minutes.textContent = '00';
            timerFields.seconds.textContent = '00';
            closeDrop();
            return;
          }

          timerFields.days.textContent = pad(Math.floor(distance / 86400000));
          timerFields.hours.textContent = pad(Math.floor((distance % 86400000) / 3600000));
          timerFields.minutes.textContent = pad(Math.floor((distance % 3600000) / 60000));
          timerFields.seconds.textContent = pad(Math.floor((distance % 60000) / 1000));
        };

        updateTimer();
        if (root.dataset.dropClosed !== 'true') timerInterval = window.setInterval(updateTimer, 1000);
      }

      const applyInventoryState = (updatedRoot) => {
        const sold = Number(updatedRoot.dataset.soldUnits);
        const limit = Number(updatedRoot.dataset.dailyLimit);
        if (!Number.isFinite(sold) || !Number.isFinite(limit) || limit < 1) return false;

        const remaining = Math.max(0, limit - sold);
        root.dataset.soldUnits = String(sold);

        if (updatedRoot.dataset.dropClosed === 'true' || remaining <= 0) {
          closeDrop();
          return true;
        }

        const progress = root.querySelector('[data-progress]');
        const progressFill = root.querySelector('[data-progress-fill]');
        const progressLabel = root.querySelector('[data-progress-label]');
        const remainingLabel = root.querySelector('[data-remaining-label]');
        const updatedProgressLabel = updatedRoot.querySelector('[data-progress-label]');
        const updatedRemainingLabel = updatedRoot.querySelector('[data-remaining-label]');
        const updatedButton = updatedRoot.querySelector('[data-add-to-cart]');

        progress?.setAttribute('aria-valuenow', String(sold));
        progressFill?.style.setProperty('--rr-flash-progress', `${(sold / limit) * 100}%`);
        if (progressLabel && updatedProgressLabel) progressLabel.textContent = updatedProgressLabel.textContent;
        if (remainingLabel && updatedRemainingLabel) remainingLabel.textContent = updatedRemainingLabel.textContent;

        const available = Boolean(updatedButton && !updatedButton.disabled && remaining > 0);
        const defaultLabel = button?.dataset.defaultLabel || mobileButton?.textContent || '';
        const soldOutLabel = button?.dataset.soldOutLabel || mobileButton?.textContent || '';
        if (button) {
          button.disabled = !available;
          button.textContent = available ? defaultLabel : soldOutLabel;
        }
        if (mobileButton) {
          mobileButton.disabled = !available;
          mobileButton.textContent = available ? defaultLabel : soldOutLabel;
        }

        return true;
      };

      const refreshInventory = async () => {
        if (root.dataset.dropClosed === 'true') return false;
        if (root.dataset.progressSource !== 'inventory' || !root.dataset.sectionId) return false;

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', root.dataset.sectionId);
          url.searchParams.set('_flash_inventory', String(Date.now()));
          const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
          if (!response.ok) return false;

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const updatedRoot = documentFragment.querySelector('[data-flash-sale-hero]');
          if (!updatedRoot) return false;
          return applyInventoryState(updatedRoot);
        } catch (error) {
          return false;
        }
      };

      if (root.dataset.progressSource === 'inventory') {
        const inventoryInterval = window.setInterval(() => {
          if (!root.isConnected || root.dataset.dropClosed === 'true') {
            window.clearInterval(inventoryInterval);
            return;
          }
          refreshInventory();
        }, 15000);
      }

      if (mobileButton && form) {
        mobileButton.addEventListener('click', () => form.requestSubmit());
      }

      if (!form || !button) return;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (button.disabled) return;

        button.disabled = true;
        if (mobileButton) mobileButton.disabled = true;
        status.textContent = '';

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this item.');

          status.textContent = 'Added to cart';
          document.dispatchEvent(new CustomEvent('flash-sale:cart-added', { detail: payload }));

          window.setTimeout(async () => {
            const refreshed = await refreshInventory();
            if (refreshed) return;

            button.disabled = false;
            button.textContent = button.dataset.defaultLabel;
            if (mobileButton) {
              mobileButton.disabled = false;
              mobileButton.textContent = button.dataset.defaultLabel;
            }
          }, 900);
        } catch (error) {
          status.textContent = error.message;
          button.disabled = false;
          button.textContent = button.dataset.defaultLabel;
          if (mobileButton) mobileButton.disabled = false;
        }
      });
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-flash-sale-hero]').forEach(initHero);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const singaporeOffsetMs = 8 * 60 * 60 * 1000;

  const nextSingaporeMidnight = () => {
    const singaporeNow = new Date(Date.now() + singaporeOffsetMs);
    return Date.UTC(
      singaporeNow.getUTCFullYear(),
      singaporeNow.getUTCMonth(),
      singaporeNow.getUTCDate() + 1,
      0,
      0,
      0
    ) - singaporeOffsetMs;
  };

  const pad = (value) => String(value).padStart(2, '0');

  const initFlashSale = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const endAt = root.dataset.endAt;
    const dailyMode = root.dataset.dailyMode === 'true';
    let deadline = dailyMode ? nextSingaporeMidnight() : Date.parse(endAt);
    const timerFields = {
      days: root.querySelector('[data-timer-days]'),
      hours: root.querySelector('[data-timer-hours]'),
      minutes: root.querySelector('[data-timer-minutes]'),
      seconds: root.querySelector('[data-timer-seconds]')
    };

    if (timerFields.seconds) {
      const updateTimer = () => {
        let distance = deadline - Date.now();

        if (distance <= 0 && dailyMode) {
          deadline = nextSingaporeMidnight();
          distance = deadline - Date.now();
        }

        distance = Math.max(0, distance);
        const days = Math.floor(distance / 86400000);
        const hours = Math.floor((distance % 86400000) / 3600000);
        const minutes = Math.floor((distance % 3600000) / 60000);
        const seconds = Math.floor((distance % 60000) / 1000);

        timerFields.days.textContent = pad(days);
        timerFields.hours.textContent = pad(hours);
        timerFields.minutes.textContent = pad(minutes);
        timerFields.seconds.textContent = pad(seconds);
      };

      updateTimer();
      window.setInterval(updateTimer, 1000);
    }

    const form = root.querySelector('.flash-sale__form');
    const button = root.querySelector('[data-add-to-cart]');
    const mobileButton = root.querySelector('[data-mobile-buy]');
    const status = root.querySelector('[data-form-status]');

    if (mobileButton && form) {
      mobileButton.addEventListener('click', () => form.requestSubmit());
    }

    if (!form || !button) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (button.disabled) return;

      button.disabled = true;
      if (mobileButton) mobileButton.disabled = true;
      button.textContent = button.dataset.loadingLabel;
      status.textContent = '';

      try {
        const response = await fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const payload = await response.json();

        if (!response.ok) {
          throw new Error(payload.description || payload.message || 'Unable to add this item.');
        }

        const limit = Number(root.dataset.dailyLimit);
        const sold = Math.min(limit, Number(root.dataset.soldUnits) + 1);
        const remaining = Math.max(0, limit - sold);
        root.dataset.soldUnits = String(sold);

        const progress = root.querySelector('[data-progress]');
        const progressFill = root.querySelector('[data-progress-fill]');
        const progressLabel = root.querySelector('[data-progress-label]');
        const remainingLabel = root.querySelector('[data-remaining-label]');
        progress?.setAttribute('aria-valuenow', String(sold));
        progressFill?.style.setProperty('--flash-progress', `${(sold / limit) * 100}%`);

        if (progressLabel) {
          progressLabel.textContent = progressLabel.textContent.replace(/^\d+/, String(sold));
        }

        if (remainingLabel) {
          remainingLabel.textContent = remainingLabel.textContent.replace(/\d+/, String(remaining));
        }

        button.textContent = button.dataset.addedLabel;
        status.textContent = payload.product_title || '';
        document.dispatchEvent(new CustomEvent('flash-sale:cart-added', { detail: payload }));

        window.setTimeout(() => {
          if (remaining === 0) {
            button.textContent = button.dataset.soldOutLabel;
            if (mobileButton) mobileButton.textContent = button.dataset.soldOutLabel;
            return;
          }

          button.disabled = false;
          button.textContent = button.dataset.defaultLabel;
          if (mobileButton) mobileButton.disabled = false;
        }, 1400);
      } catch (error) {
        status.textContent = error.message;
        button.disabled = false;
        button.textContent = button.dataset.defaultLabel;
        if (mobileButton) mobileButton.disabled = false;
      }
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-flash-sale]').forEach(initFlashSale);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('floating-contact')) {
    customElements.define('floating-contact', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');

        document.addEventListener('click', (event) => {
          if (this.details.open && !this.contains(event.target)) this.details.open = false;
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            this.details.open = false;
            this.summary.focus();
          }
        });

        this.querySelectorAll('[data-contact-action]').forEach((link) => {
          link.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: `${link.dataset.contactAction}_click` });
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initComparison = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const maxProducts = Number(root.dataset.maxProducts || 3);
    const picker = root.querySelector('[data-product-picker]');
    const productOptions = Array.from(root.querySelectorAll('[data-product-option]'));
    const categories = [...new Set(productOptions.map((option) => option.dataset.category))];
    const url = new URL(window.location.href);
    const requestedCategory = url.searchParams.get('compare_category');
    let activeCategory = categories.includes(requestedCategory) ? requestedCategory : root.dataset.defaultCategory;
    const selected = {};
    let draftSelection = [];
    let pageScrollY = 0;
    let pageScrollLocked = false;
    let previousBodyStyles = {};
    const themeHeader = document.querySelector('.section-header');

    const updateStickyHeaderOffset = () => {
      if (!themeHeader) return;
      const isSticky = themeHeader.classList.contains('shopify-section-header-sticky');
      const isHidden = themeHeader.classList.contains('shopify-section-header-hidden');
      const offset = isSticky && !isHidden ? themeHeader.offsetHeight : 0;
      root.style.setProperty('--rr-compare-header-offset', `${offset}px`);
    };

    const headerClassObserver = themeHeader
      ? new MutationObserver(updateStickyHeaderOffset)
      : null;
    const headerSizeObserver = themeHeader && 'ResizeObserver' in window
      ? new ResizeObserver(updateStickyHeaderOffset)
      : null;

    if (themeHeader) {
      headerClassObserver.observe(themeHeader, { attributes: true, attributeFilter: ['class'] });
      headerSizeObserver?.observe(themeHeader);
      window.addEventListener('resize', updateStickyHeaderOffset, { passive: true });
      updateStickyHeaderOffset();
    }

    const lockPageScroll = () => {
      if (pageScrollLocked) return;
      pageScrollY = window.scrollY;
      previousBodyStyles = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
        overflow: document.body.style.overflow
      };
      document.documentElement.classList.add('rr-compare-picker-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${pageScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      pageScrollLocked = true;
    };

    const unlockPageScroll = () => {
      if (!pageScrollLocked) return;
      document.documentElement.classList.remove('rr-compare-picker-open');
      Object.entries(previousBodyStyles).forEach(([property, value]) => {
        document.body.style[property] = value;
      });
      pageScrollLocked = false;
      window.scrollTo(0, pageScrollY);
    };

    const poolFor = (category) => productOptions
      .filter((option) => option.dataset.category === category)
      .map((option) => option.dataset.productHandle);

    categories.forEach((category) => {
      const pool = poolFor(category);
      const requested = category === activeCategory
        ? (url.searchParams.get('compare') || '').split(',').filter((handle) => pool.includes(handle))
        : [];
      selected[category] = [...new Set(requested)].slice(0, maxProducts);
      if (selected[category].length < Math.min(2, pool.length)) {
        selected[category] = pool.slice(0, Math.min(2, pool.length));
      }
    });

    const track = (eventName, detail = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...detail });
    };

    const updateUrl = () => {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('compare_category', activeCategory);
      nextUrl.searchParams.set('compare', selected[activeCategory].join(','));
      window.history.replaceState({}, '', nextUrl);
    };

    const updateDifferences = () => {
      const panel = root.querySelector(`[data-category-panel="${activeCategory}"]`);
      const differencesOnly = root.querySelector('[data-differences-only]')?.checked;
      if (!panel) return;

      panel.querySelectorAll('[data-spec-row]').forEach((row) => {
        const values = Array.from(row.querySelectorAll('[data-product-column]:not([hidden])'))
          .map((cell) => cell.dataset.value.trim().toLowerCase());
        const different = new Set(values).size > 1;
        row.dataset.different = String(different);
        row.hidden = Boolean(differencesOnly && !different);
      });

      panel.querySelectorAll('[data-spec-group]').forEach((group) => {
        const hasVisibleRows = Array.from(group.querySelectorAll('[data-spec-row]')).some((row) => !row.hidden);
        group.hidden = !hasVisibleRows;
      });
    };

    const render = ({ announce = true } = {}) => {
      root.querySelectorAll('[data-category-tab]').forEach((tab) => {
        const isActive = tab.dataset.categoryTab === activeCategory;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      root.querySelectorAll('[data-category-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.categoryPanel !== activeCategory;
      });

      root.querySelectorAll('[data-product-column]').forEach((column) => {
        const visible = column.dataset.category === activeCategory && selected[activeCategory].includes(column.dataset.productHandle);
        column.hidden = !visible;
        const removeButton = column.querySelector('[data-remove-product]');
        if (removeButton) removeButton.hidden = !visible || selected[activeCategory].length <= 2;
      });

      root.querySelectorAll('[data-comparison-stage]').forEach((stage) => {
        stage.style.setProperty('--compare-count', String(Math.max(selected[activeCategory].length, 1)));
      });

      const status = root.querySelector('[data-comparison-status]');
      if (status && announce) {
        status.textContent = root.dataset.selectedLabel.replace('__count__', String(selected[activeCategory].length));
      }

      updateDifferences();
      updateUrl();
    };

    const renderPicker = () => {
      const query = root.querySelector('[data-picker-search]')?.value.trim().toLowerCase() || '';
      let visibleCount = 0;

      productOptions.forEach((option) => {
        const inCategory = option.dataset.category === activeCategory;
        const matchesSearch = option.dataset.productTitle.toLowerCase().includes(query);
        const isSelected = draftSelection.includes(option.dataset.productHandle);
        option.hidden = !(inCategory && matchesSearch);
        option.setAttribute('aria-pressed', String(isSelected));
        option.disabled = !isSelected && draftSelection.length >= maxProducts;
        if (!option.hidden) visibleCount += 1;
      });

      const count = root.querySelector('[data-picker-count]');
      const apply = root.querySelector('[data-apply-products]');
      const empty = root.querySelector('[data-picker-empty]');
      if (count) count.textContent = root.dataset.selectedLabel.replace('__count__', String(draftSelection.length));
      if (apply) apply.disabled = draftSelection.length < Math.min(2, poolFor(activeCategory).length);
      if (empty) empty.hidden = visibleCount > 0;
    };

    root.querySelectorAll('[data-category-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        activeCategory = tab.dataset.categoryTab;
        render();
        track('compare_category_changed', { compare_category: activeCategory });
      });
    });

    root.querySelector('[data-open-picker]')?.addEventListener('click', () => {
      draftSelection = [...selected[activeCategory]];
      const search = root.querySelector('[data-picker-search]');
      if (search) search.value = '';
      renderPicker();
      if (picker && !picker.open) {
        lockPageScroll();
        picker.showModal();
        window.requestAnimationFrame(() => search?.focus({ preventScroll: true }));
      }
    });

    productOptions.forEach((option) => {
      option.addEventListener('click', () => {
        const handle = option.dataset.productHandle;
        if (draftSelection.includes(handle)) {
          draftSelection = draftSelection.filter((item) => item !== handle);
        } else if (draftSelection.length < maxProducts) {
          draftSelection.push(handle);
        }
        renderPicker();
      });
    });

    root.querySelector('[data-picker-search]')?.addEventListener('input', renderPicker);

    root.querySelector('[data-apply-products]')?.addEventListener('click', () => {
      if (draftSelection.length < Math.min(2, poolFor(activeCategory).length)) {
        const status = root.querySelector('[data-comparison-status]');
        if (status) status.textContent = root.dataset.minimumLabel;
        return;
      }
      selected[activeCategory] = [...draftSelection];
      picker?.close();
      render();
      track('compare_products_applied', {
        compare_category: activeCategory,
        compare_products: selected[activeCategory].join(',')
      });
    });

    root.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-remove-product]');
      if (!removeButton) return;
      const minimum = Math.min(2, poolFor(activeCategory).length);
      if (selected[activeCategory].length <= minimum) {
        const status = root.querySelector('[data-comparison-status]');
        if (status) status.textContent = root.dataset.minimumLabel;
        return;
      }
      selected[activeCategory] = selected[activeCategory].filter((handle) => handle !== removeButton.dataset.removeProduct);
      render();
    });

    root.querySelector('[data-differences-only]')?.addEventListener('change', (event) => {
      updateDifferences();
      track('compare_differences_toggled', { enabled: event.target.checked });
    });

    root.querySelector('[data-share-comparison]')?.addEventListener('click', async () => {
      updateUrl();
      const shareData = { title: document.title, url: window.location.href };
      try {
        if (navigator.share) {
          await navigator.share(shareData);
        } else {
          await navigator.clipboard.writeText(window.location.href);
          const status = root.querySelector('[data-comparison-status]');
          if (status) status.textContent = root.dataset.linkCopiedLabel;
        }
        track('compare_shared', { compare_category: activeCategory });
      } catch (error) {
        if (error.name !== 'AbortError') {
          const status = root.querySelector('[data-comparison-status]');
          if (status) status.textContent = window.location.href;
        }
      }
    });

    picker?.addEventListener('click', (event) => {
      if (event.target === picker) picker.close();
    });

    picker?.addEventListener('close', unlockPageScroll);

    const cleanupComparison = (event) => {
      if (!event.target.contains(root)) return;
      headerClassObserver?.disconnect();
      headerSizeObserver?.disconnect();
      window.removeEventListener('resize', updateStickyHeaderOffset);
      document.removeEventListener('shopify:section:unload', cleanupComparison);
    };
    document.addEventListener('shopify:section:unload', cleanupComparison);

    render({ announce: false });
  };

  const initAllComparisons = (scope = document) => {
    scope.querySelectorAll('[data-product-comparison]').forEach(initComparison);
  };

  initAllComparisons();
  document.addEventListener('shopify:section:load', (event) => initAllComparisons(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roadshow-landing-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const filterButton = event.target.closest('[data-roadshow-filter]');
    if (!filterButton) return;

    const section = filterButton.closest('[data-roadshow-landing]');
    if (!section) return;

    const selectedSeries = filterButton.dataset.roadshowFilter;
    const cards = section.querySelectorAll('[data-roadshow-series]');
    let visibleCount = 0;

    section.querySelectorAll('[data-roadshow-filter]').forEach((button) => {
      const isActive = button === filterButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    cards.forEach((card) => {
      const isVisible = selectedSeries === 'all' || card.dataset.roadshowSeries === selectedSeries;
      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    const count = section.querySelector('[data-roadshow-count]');
    if (count) count.textContent = `${visibleCount} ${visibleCount === 1 ? 'model' : 'models'}`;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roadshow-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-roadshow-thumb]');
    if (!thumb) return;

    const section = thumb.closest('.roadshow-product');
    const image = section?.querySelector('.roadshow-product__main-image');
    if (!image) return;

    image.style.opacity = '0';
    window.setTimeout(() => {
      image.src = thumb.dataset.imageSrc;
      image.srcset = '';
      image.alt = thumb.dataset.imageAlt || '';
      image.style.opacity = '1';
    }, 120);

    section.querySelectorAll('[data-roadshow-thumb]').forEach((button) => {
      const active = button === thumb;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-roadshow-variant]');
    if (!select) return;

    const section = select.closest('.roadshow-product');
    const option = select.selectedOptions[0];
    const price = section?.querySelector('[data-roadshow-price]');
    const compare = section?.querySelector('[data-roadshow-compare]');
    const submit = section?.querySelector('[data-roadshow-submit]');

    if (price) price.textContent = option.dataset.price || '';
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = option.dataset.onSale !== 'true';
    }
    if (submit) submit.disabled = option.dataset.available !== 'true';
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.roadshow-product__form');
    if (!form) return;

    event.preventDefault();

    const section = form.closest('[data-roadshow-section]');
    const serviceSelect = form.querySelector('[data-roadshow-service]');
    const submit = form.querySelector('[data-roadshow-submit]');
    const submitLabel = form.querySelector('[data-roadshow-submit-label]');
    const errorMessage = form.querySelector('[data-roadshow-form-error]');
    const originalLabel = submitLabel?.textContent;

    if (!section || !serviceSelect || !submit) return;

    if (errorMessage) {
      errorMessage.hidden = true;
      errorMessage.textContent = '';
    }

    submit.disabled = true;
    if (submitLabel) submitLabel.textContent = submit.dataset.loadingLabel || 'Adding…';

    try {
      const formData = new FormData(form);
      const variantId = Number(formData.get('id'));
      const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
      const selectedService = serviceSelect.selectedOptions[0];
      const properties = {};

      formData.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim()) properties[match[1]] = String(value);
      });

      properties['Roadshow service'] = selectedService.dataset.serviceLabel || selectedService.textContent.trim();

      const items = [{ id: variantId, quantity, properties }];

      if (serviceSelect.value === 'addon') {
        const serviceVariantId = Number(section.dataset.serviceVariantId);
        if (!serviceVariantId) throw new Error(section.dataset.cartError);

        items.push({
          id: serviceVariantId,
          quantity,
          properties: {
            'Covered product': section.dataset.productTitle,
            'Delivery Schedule': properties['Delivery Schedule'],
            'Promoter': properties.Promoter
          }
        });
      }

      const response = await fetch(section.dataset.cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const responseBody = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(responseBody.description || responseBody.message || section.dataset.cartError);
      }

      const orderAttributes = {
        'Delivery Schedule': properties['Delivery Schedule'],
        'Promoter': properties.Promoter
      };

      const attributesResponse = await fetch(section.dataset.cartUpdateUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: orderAttributes })
      });

      if (!attributesResponse.ok) {
        console.warn('Roadshow order attributes could not be saved. The line-item properties remain attached to the product.');
      }

      window.location.assign(section.dataset.cartUrl);
    } catch (error) {
      if (errorMessage) {
        errorMessage.textContent = error.message || section.dataset.cartError;
        errorMessage.hidden = false;
      }
      submit.disabled = false;
      if (submitLabel) submitLabel.textContent = originalLabel;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roborock-app-experience"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rr-appx').forEach((root)=>{
    const dialog=root.querySelector('[data-app-video-dialog]');
    root.querySelector('[data-app-video-open]')?.addEventListener('click',()=>dialog?.showModal());
    root.querySelector('[data-app-video-close]')?.addEventListener('click',()=>dialog?.close());
    dialog?.addEventListener('click',(event)=>{if(event.target===dialog)dialog.close();});
    root.querySelectorAll('[data-clean-modes]').forEach((module)=>{
      const tabs=[...module.querySelectorAll('[data-clean-mode]')];
      const panels=[...module.querySelectorAll('[data-clean-panel]')];
      const activate=(tab)=>{
        tabs.forEach((item)=>{const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;});
        panels.forEach((panel)=>{panel.hidden=panel.dataset.cleanPanel!==tab.dataset.cleanMode;});
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>activate(tab));
        tab.addEventListener('keydown',(event)=>{
          let target=index;
          if(event.key==='ArrowRight'||event.key==='ArrowDown')target=(index+1)%tabs.length;
          else if(event.key==='ArrowLeft'||event.key==='ArrowUp')target=(index-1+tabs.length)%tabs.length;
          else if(event.key==='Home')target=0;
          else if(event.key==='End')target=tabs.length-1;
          else return;
          event.preventDefault();activate(tabs[target]);tabs[target].focus();
        });
      });
    });
    root.querySelectorAll('[data-clean-method]').forEach((module)=>{
      const tabs=[...module.querySelectorAll('[data-method-tab]')];
      const panels=[...module.querySelectorAll('[data-method-panel]')];
      const activate=(tab)=>{
        tabs.forEach((item)=>{const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;});
        panels.forEach((panel)=>{panel.hidden=panel.dataset.methodPanel!==tab.dataset.methodTab;});
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>activate(tab));
        tab.addEventListener('keydown',(event)=>{
          let target=index;
          if(event.key==='ArrowRight'||event.key==='ArrowDown')target=(index+1)%tabs.length;
          else if(event.key==='ArrowLeft'||event.key==='ArrowUp')target=(index-1+tabs.length)%tabs.length;
          else if(event.key==='Home')target=0;
          else if(event.key==='End')target=tabs.length-1;
          else return;
          event.preventDefault();activate(tabs[target]);tabs[target].focus();
        });
      });
    });
    root.querySelectorAll('[data-remote-control]').forEach((module)=>{
      const tabs=[...module.querySelectorAll('[data-remote-tab]')];
      const panels=[...module.querySelectorAll('[data-remote-panel]')];
      const activate=(tab,focus=false)=>{
        tabs.forEach((item)=>{const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;});
        panels.forEach((panel)=>{
          const active=panel.dataset.remotePanel===tab.dataset.remoteTab;
          panel.hidden=!active;
          const video=panel.querySelector('video');
          if(video){if(active)video.play().catch(()=>{});else video.pause();}
        });
        if(focus)tab.focus();
      };
      const move=(step,focus=false)=>{
        const selected=tabs.findIndex((tab)=>tab.getAttribute('aria-selected')==='true');
        activate(tabs[(selected+step+tabs.length)%tabs.length],focus);
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>activate(tab));
        tab.addEventListener('keydown',(event)=>{
          let target=index;
          if(event.key==='ArrowRight'||event.key==='ArrowDown')target=(index+1)%tabs.length;
          else if(event.key==='ArrowLeft'||event.key==='ArrowUp')target=(index-1+tabs.length)%tabs.length;
          else if(event.key==='Home')target=0;
          else if(event.key==='End')target=tabs.length-1;
          else return;
          event.preventDefault();activate(tabs[target],true);
        });
      });
      module.querySelector('[data-remote-direction="previous"]')?.addEventListener('click',()=>move(-1));
      module.querySelector('[data-remote-direction="next"]')?.addEventListener('click',()=>move(1));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roborock-auction-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.querySelector('.rr-auction-product');

  if (!section || section.dataset.auctionUxReady === 'true') return;

  section.dataset.auctionUxReady = 'true';
  let dialogWasOpen = false;
  let dialogTrigger = null;

  const registration = section.querySelector('[data-auction-mobile-registration]');

  if (registration) {
    const customerEmail = registration.dataset.customerEmail?.trim();
    let formWasSubmitted = false;
    let reloadScheduled = false;
    let observedFormRoot = null;
    let registrationObserver;

    const setNativeValue = (input, value) => {
      const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
      setter?.call(input, value);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const prepareRegistrationForm = () => {
      const formEmbed = registration.querySelector('shopify-forms-embed');
      const formRoot = formEmbed?.shadowRoot || registration;
      const form = formRoot.querySelector('[data-testid="form"]');
      const emailInput = formRoot.querySelector('[data-testid="field-email"]');
      const appHeading = formRoot.querySelector('h2');

      if (formEmbed?.shadowRoot && observedFormRoot !== formEmbed.shadowRoot) {
        observedFormRoot = formEmbed.shadowRoot;
        registrationObserver.observe(observedFormRoot, { childList: true, subtree: true });
      }

      if (appHeading?.parentElement) {
        appHeading.parentElement.setAttribute('data-auction-form-intro', '');
        appHeading.parentElement.style.setProperty('display', 'none', 'important');
      }

      if (form && form.dataset.auctionSubmitReady !== 'true') {
        form.dataset.auctionSubmitReady = 'true';
        form.addEventListener('submit', () => { formWasSubmitted = true; });
      }

      if (emailInput) {
        if (customerEmail && emailInput.value !== customerEmail) setNativeValue(emailInput, customerEmail);
        const emailField = emailInput.closest('div');

        if (emailField) {
          emailField.setAttribute('hidden', '');
          emailField.setAttribute('aria-hidden', 'true');
          emailField.style.setProperty('display', 'none', 'important');
        }
      }

      if (formWasSubmitted && !form && !reloadScheduled) {
        reloadScheduled = true;
        window.setTimeout(() => window.location.reload(), 1400);
      }
    };

    registrationObserver = new MutationObserver(prepareRegistrationForm);
    registrationObserver.observe(registration, { childList: true, subtree: true });
    prepareRegistrationForm();
  }

  const gallery = section.querySelector('[data-auction-gallery]');

  if (gallery) {
    const stage = gallery.querySelector('.rr-auction-product__gallery-stage');
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    const current = gallery.querySelector('[data-gallery-current]');
    let activeIndex = 0;
    let scrollFrame = null;

    const updateGallery = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      const mediaRatio = Number(slides[activeIndex]?.dataset.mediaRatio) || 1;
      const displayRatio = Math.min(1.35, Math.max(.78, mediaRatio));

      stage?.style.setProperty('--rr-gallery-ratio', String(displayRatio));

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.toggleAttribute('inert', !isActive);

        if (!isActive) slide.querySelectorAll('video').forEach((video) => video.pause());
      });

      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const isActive = thumbnailIndex === activeIndex;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (current) current.textContent = String(activeIndex + 1);
    };

    const showMedia = (index) => {
      if (!track || slides.length < 2) return;

      const wrappedIndex = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[wrappedIndex].offsetLeft, behavior: 'smooth' });
      updateGallery(wrappedIndex);
      thumbnails[wrappedIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };

    previous?.addEventListener('click', () => showMedia(activeIndex - 1));
    next?.addEventListener('click', () => showMedia(activeIndex + 1));

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => showMedia(Number(thumbnail.dataset.galleryThumbnail)));
    });

    track?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      showMedia(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });

    track?.addEventListener('scroll', () => {
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);

      scrollFrame = window.requestAnimationFrame(() => {
        const nearestIndex = slides.reduce((nearest, slide, index) => {
          const nearestDistance = Math.abs(slides[nearest].offsetLeft - track.scrollLeft);
          const slideDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
          return slideDistance < nearestDistance ? index : nearest;
        }, 0);

        if (nearestIndex !== activeIndex) updateGallery(nearestIndex);
      });
    }, { passive: true });

    updateGallery(0);
  }

  const enhanceWidget = () => {
    const widget = section.querySelector('#codeBlock-auction-widget');
    const bidCount = section.querySelector('#codeBlock-no-of-bids');
    const viewAll = section.querySelector('#view-all-section');
    const countdown = section.querySelector('#auction-today-countdown');

    if (!widget) return;

    widget.classList.add('rr-auction-widget--enhanced');

    if (bidCount && viewAll) {
      const bidRow = bidCount.closest('.auction-details-list-item');

      if (bidRow && viewAll.parentElement !== bidRow) {
        bidRow.classList.add('rr-auction-bids-row');
        bidRow.append(viewAll);
      }
    }

    if (countdown) countdown.setAttribute('aria-live', 'off');

    section.querySelectorAll('.codeBlock-bid-response, .codeBlock-auction-is-highest-bidder, .codeBlock-auction-is-outbid-message, .codeBlock-auction-automatic-bidding-response').forEach((message) => {
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
    });

    const viewAllButton = section.querySelector('.view-all-bids-button');
    if (viewAllButton) viewAllButton.setAttribute('type', 'button');
  };

  const enhanceDialog = () => {
    const modal = document.querySelector('.tingle-modal--visible');

    if (!modal || !dialogTrigger) {
      if (dialogWasOpen && dialogTrigger && document.contains(dialogTrigger)) dialogTrigger.focus();
      dialogWasOpen = false;
      return;
    }

    const box = modal.querySelector('.tingle-modal-box');
    const content = modal.querySelector('.tingle-modal-box__content');
    const closeButton = modal.querySelector('.tingle-modal__close');
    const heading = content?.querySelector('h1, h2, h3, h4, h5, h6');
    const table = content?.querySelector('table');
    const firstEnhancement = modal.dataset.auctionDialogReady !== 'true';

    modal.dataset.auctionDialogReady = 'true';
    modal.classList.add('rr-auction-modal');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');

    if (heading) {
      if (!heading.id) heading.id = 'rr-auction-dialog-title';
      modal.setAttribute('aria-labelledby', heading.id);
    }

    if (box && closeButton && closeButton.parentElement !== box) box.prepend(closeButton);

    if (closeButton) {
      closeButton.setAttribute('type', 'button');
      closeButton.setAttribute('aria-label', section.dataset.dialogCloseLabel);
    }

    if (table) {
      const rows = [...table.rows];
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emailColumn = rows.reduce((found, row) => {
        if (found > -1) return found;
        return [...row.cells].findIndex((cell) => emailPattern.test(cell.textContent.trim()));
      }, -1);

      if (emailColumn > -1) {
        const nameColumn = emailColumn - 1;
        const nameHeading = table.querySelector(`thead tr > *:nth-child(${nameColumn + 1})`);

        if (nameHeading) nameHeading.textContent = section.dataset.bidderLabel;

        table.querySelectorAll('tbody tr').forEach((row) => {
          const nameCell = row.cells[nameColumn];
          const fullName = nameCell?.textContent.trim() || '';

          if (nameCell && fullName) {
            const nameParts = fullName.split(/\s+/);
            const visibleName = nameParts.length > 1 ? nameParts[0] : fullName.slice(0, Math.max(1, fullName.length - 3));
            nameCell.textContent = `${visibleName} XXX`;
          }
        });

        rows.forEach((row) => row.cells[emailColumn]?.remove());
      }

      table.classList.add('rr-auction-history-table');
      const labels = [...table.querySelectorAll('thead th')].map((cell) => cell.textContent.trim());

      table.querySelectorAll('tbody tr').forEach((row) => {
        [...row.cells].forEach((cell, index) => cell.setAttribute('data-label', labels[index] || ''));
      });
    }

    if (firstEnhancement) {
      dialogWasOpen = true;
      window.requestAnimationFrame(() => closeButton?.focus());
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.view-all-bids-button');

    if (!button || !section.contains(button)) return;

    dialogTrigger = button;
    window.setTimeout(enhanceDialog, 0);
  });

  const observer = new MutationObserver(enhanceWidget);
  const dialogObserver = new MutationObserver(enhanceDialog);
  observer.observe(section, { childList: true, subtree: true });
  dialogObserver.observe(document.body, { childList: true, subtree: true });
  enhanceWidget();
})();

(() => {
  const maskWinner = (value, fallback) => {
    const name = String(value || '').trim();
    if (!name || name.includes('@')) return fallback;
    return Array.from(name)[0] + '***';
  };
  const isMatchingWinner = (bid, auctionId, productId, variantId) =>
    bid.status === 'WINNER' && String(bid.auctionId || bid.auction?.id) === String(auctionId)
    && String(bid.productId) === String(productId) && String(bid.variantId) === String(variantId);
  const loadWinners = async (panel, auction, productId, variantId) => {
    const winners = new Map();
    for (let page = 0; page < 20; page += 1) {
      const params = new URLSearchParams({shop:panel.dataset.shop,type:'ALL',productId,variantId,customerId:'0',auctionId:String(auction.id),status:'WINNER',page:String(page),size:'50',sort:'amount,desc'});
      const response = await fetch('/apps/auction-today/customer-portal/api/auction-biddings/by-shop?' + params, {credentials:'omit',signal:AbortSignal.timeout(10000),cache:'no-store'});
      if (!response.ok) throw new Error('Result unavailable');
      const bids = await response.json();
      if (!Array.isArray(bids)) throw new Error('Invalid result');
      bids.filter(bid => isMatchingWinner(bid,auction.id,productId,variantId)).forEach(bid => winners.set(String(bid.id), {name:maskWinner(bid.customerName,panel.dataset.bidder),amount:bid.amount,currency:bid.currency}));
      const total = Number(response.headers.get('x-total-count'));
      if (bids.length < 50 || (total > 0 && (page+1)*50 >= total)) return [...winners.values()];
    }
    throw new Error('Incomplete result');
  };
  const init = (section) => {
    const panel = section.querySelector('[data-auction-result]');
    if (!panel || panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';
    let busy=false, lastRequest=0, lastAuctionId=null;
    const refresh = async () => {
      if (!section.isConnected || busy) return;
      const utils=window.CodeBlockUtils;
      const anchor=section.querySelector('.rr-auction-product__widget-anchor');
      if (!utils?.detectAuction || !utils?.isExpired || !anchor || !window.codeBlockAuction?.auctions) return;
      const productId=anchor.dataset.productId, variantId=anchor.dataset.variantId;
      let auction=utils.detectAuction(productId,variantId);
      if (!auction) auction=window.codeBlockAuction.auctions
        .filter(entry => !entry.applyAcrossStore && entry.products?.some(product => String(product.productId) === productId && String(product.variantId) === variantId))
        .sort((a,b)=>Number(b.id)-Number(a.id))[0];
      const ended=auction && (auction.status === 'END' || utils.isExpired(auction));
      panel.hidden=!ended;
      section.classList.toggle('rr-auction-product--ended',Boolean(ended));
      if (!ended) { lastAuctionId=null; return; }
      if (Date.now()-lastRequest < 60000 && lastAuctionId === auction.id) return;
      busy=true; lastRequest=Date.now(); lastAuctionId=auction.id;
      const heading=panel.querySelector('[data-result-heading]');
      const message=panel.querySelector('[data-result-message]');
      const list=panel.querySelector('[data-result-winners]');
      const privacy=panel.querySelector('[data-result-privacy]');
      try {
        const winners=await loadWinners(panel,auction,productId,variantId);
        const fragment=document.createDocumentFragment();
        winners.forEach(winner => {
          const row=document.createElement('div'); row.className='rr-auction-result__winner';
          let amount='';
          if (winner.amount != null && Number.isFinite(Number(winner.amount)) && /^[A-Z]{3}$/.test(winner.currency || '')) {
            amount=new Intl.NumberFormat(panel.dataset.locale || 'en',{style:'currency',currency:winner.currency,currencyDisplay:'code'}).format(Number(winner.amount));
          }
          [[panel.dataset.winnerLabel,winner.name],[panel.dataset.amountLabel,amount]].filter(([,value])=>value).forEach(([label,value])=>{
            const group=document.createElement('div'),caption=document.createElement('span'),text=document.createElement('strong');
            caption.textContent=label; text.textContent=value; group.append(caption,text); row.append(group);
          });
          fragment.append(row);
        });
        list.replaceChildren(fragment); list.hidden=!winners.length; privacy.hidden=!winners.length;
        heading.textContent=winners.length ? panel.dataset.declared : panel.dataset.pending;
        message.hidden=Boolean(winners.length); message.textContent=panel.dataset.pendingText;
      } catch {
        if (list.hidden) { heading.textContent=panel.dataset.pending; message.hidden=false; message.textContent=panel.dataset.unavailable; }
      } finally { busy=false; }
    };
    refresh();
    let attempts=0;
    const startup=setInterval(()=>{refresh();if(++attempts>=40 || !section.isConnected) clearInterval(startup);},500);
    const timer=setInterval(()=>{if (!section.isConnected) clearInterval(timer);else if(!document.hidden) refresh();},30000);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh();});
  };
  document.querySelectorAll('.rr-auction-product').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.rr-auction-product').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roborock-catalog-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (scope) => scope.querySelectorAll('.rr-catalog').forEach((root) => {
      if (root.dataset.catalogInitialised) return;
      root.dataset.catalogInitialised = 'true';
      const current = new URL(window.location.href);
      root.querySelectorAll('[data-auto-submit]').forEach((select) => select.addEventListener('change', () => {
        const destination = new URL(window.location.href);
        destination.searchParams.set('sort_by', select.value);
        destination.searchParams.delete('page');
        window.location.assign(destination.href);
      }));
      root.querySelector('[data-filter-panel] form')?.addEventListener('submit', (event) => {
        event.preventDefault();
        const destination = new URL(window.location.href);
        [...destination.searchParams.keys()].forEach((key) => {
          if (key.startsWith('filter.') || key === 'page' || key === 'sort_by') destination.searchParams.delete(key);
        });
        for (const [key, value] of new FormData(event.currentTarget)) {
          if (value !== '') destination.searchParams.append(key, value);
        }
        window.location.assign(destination.href);
      });
      root.querySelectorAll('a[href]').forEach((link) => {
        const destination = new URL(link.href);
        if (destination.origin !== current.origin || destination.pathname !== current.pathname) return;
        ['view', 'preview_theme_id'].forEach((key) => {
          if (current.searchParams.has(key)) destination.searchParams.set(key, current.searchParams.get(key));
        });
        link.href = destination.href;
      });
      const toggle = root.querySelector('[data-filter-toggle]');
      const panel = root.querySelector('[data-filter-panel]');
      toggle?.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        panel.dataset.open = String(open);
      });
    });
    initialise(document);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roborock-family-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rr-family').forEach((root)=>{const rail=root.querySelector('[data-family-rail]');if(!rail)return;const move=(direction)=>rail.scrollBy({left:direction*Math.min(rail.clientWidth*.86,540),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});root.querySelector('[data-family-prev]')?.addEventListener('click',()=>move(-1));root.querySelector('[data-family-next]')?.addEventListener('click',()=>move(1));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roborock-real-madrid"] && !Shopify.designMode) return;
  try {
    
  function initRealMadrid(scope) {
    scope.querySelectorAll('.rr-rm').forEach(root=>{
      if(root.dataset.rmReady)return;
      root.dataset.rmReady='true';
      const dialog=root.querySelector('[data-rm-dialog]'), frame=root.querySelector('[data-rm-frame]');
      let trigger, oldOverflow;
      root.querySelectorAll('[data-rm-video]').forEach(button=>button.addEventListener('click',()=>{
        const id=button.dataset.rmVideo;
        if(!/^[a-zA-Z0-9_-]{11}$/.test(id))return;
        trigger=button;
        const iframe=document.createElement('iframe');
        iframe.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0';
        iframe.title=button.querySelector('strong')?.textContent||button.getAttribute('aria-label');
        iframe.allow='autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen=true;
        frame.replaceChildren(iframe);
        oldOverflow=document.body.style.overflow;
        document.body.style.overflow='hidden';
        dialog.showModal();
      }));
      root.querySelector('[data-rm-close]')?.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{
        const rect=dialog.getBoundingClientRect();
        if(event.target===dialog&&(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom))dialog.close();
      });
      dialog.addEventListener('close',()=>{frame.replaceChildren();document.body.style.overflow=oldOverflow||'';trigger?.focus()});
      root.querySelector('[data-rm-load]')?.addEventListener('click',event=>{
        const extra=root.querySelectorAll('.rr-rm__moment--extra');
        extra.forEach(item=>item.classList.add('is-visible'));
        event.currentTarget.hidden=true;
        extra[0]?.focus();
      });
      const motion=matchMedia('(prefers-reduced-motion: reduce)');
      const respectMotion=()=>{if(motion.matches)root.querySelectorAll('video').forEach(video=>video.pause())};
      root.querySelectorAll('video').forEach(video=>video.addEventListener('loadeddata',respectMotion));
      motion.addEventListener('change',respectMotion);respectMotion();
    });
  }
  initRealMadrid(document);
  document.addEventListener('shopify:section:load',event=>initRealMadrid(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roborock-store-hub"] && !Shopify.designMode) return;
  try {
    
  function initStoreHub(scope) {
    scope.querySelectorAll('.rr-store').forEach(root=>{
      if(root.dataset.storeReady)return;root.dataset.storeReady='true';
      const rail=root.querySelector('[data-store-rail]');
      const move=d=>rail?.scrollBy({left:d*Math.min(rail.clientWidth*.86,520),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      root.querySelector('[data-store-prev]')?.addEventListener('click',()=>move(-1));
      root.querySelector('[data-store-next]')?.addEventListener('click',()=>move(1));
      const tabs=[...root.querySelectorAll('[data-store-tab]')];
      const select=tab=>{
        tabs.forEach(item=>{item.setAttribute('aria-selected',String(item===tab));item.tabIndex=item===tab?0:-1});
        root.querySelectorAll('[data-store-panel]').forEach(panel=>panel.hidden=panel.dataset.storePanel!==tab.dataset.storeTab);
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>select(tab));
        tab.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight')next=tabs[(index+1)%tabs.length];
          if(event.key==='ArrowLeft')next=tabs[(index-1+tabs.length)%tabs.length];
          if(event.key==='Home')next=tabs[0];
          if(event.key==='End')next=tabs[tabs.length-1];
          if(next){event.preventDefault();select(next);next.focus()}
        });
      });
      if(tabs[0])select(tabs[0]);
    });
  }
  initStoreHub(document);
  document.addEventListener('shopify:section:load',event=>initStoreHub(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roborock-trust-center"] && !Shopify.designMode) return;
  try {
    
  function initTrustMedia(scope) {
    scope.querySelectorAll('.rr-trust').forEach(root=>{
      if(root.dataset.trustReady)return;root.dataset.trustReady='true';
      const motion=matchMedia('(prefers-reduced-motion: reduce)');
      const respectMotion=()=>{if(motion.matches)root.querySelectorAll('video').forEach(video=>video.pause())};
      root.querySelectorAll('video').forEach(video=>video.addEventListener('loadeddata',respectMotion));
      motion.addEventListener('change',respectMotion);respectMotion();
    });
  }
  initTrustMedia(document);
  document.addEventListener('shopify:section:load',event=>initTrustMedia(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-app-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (scope) => {
      scope.querySelectorAll('.rr-app-hero').forEach((root) => {
        if (root.dataset.videoInitialised) return;
        const trigger = root.querySelector('[data-app-video-open]');
        const dialog = root.querySelector('[data-app-video-dialog]');
        const frame = root.querySelector('[data-app-video-frame]');
        if (!trigger || !dialog || !frame) return;
        root.dataset.videoInitialised = 'true';
        let previousOverflow = '';
        trigger.addEventListener('click', (event) => {
          const url = new URL(trigger.href);
          let embed;
          if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be', 'www.youtube-nocookie.com'].includes(url.hostname)) {
            const id = url.hostname === 'youtu.be' ? url.pathname.slice(1) : url.searchParams.get('v') || url.pathname.split('/').pop();
            if (!/^[a-zA-Z0-9_-]{11}$/.test(id || '')) return;
            embed = document.createElement('iframe');
            embed.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
          } else if (['vimeo.com', 'www.vimeo.com', 'player.vimeo.com'].includes(url.hostname)) {
            const id = url.pathname.split('/').pop();
            if (!/^\d+$/.test(id || '')) return;
            embed = document.createElement('iframe');
            embed.src = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
          } else if (url.protocol === 'https:' && /\.mp4$/i.test(url.pathname)) {
            embed = document.createElement('video');
            embed.src = url.href;
            embed.controls = true;
            embed.autoplay = true;
            embed.playsInline = true;
          } else return;
          event.preventDefault();
          embed.title = dialog.getAttribute('aria-label');
          if (embed.tagName === 'IFRAME') {
            embed.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            embed.allowFullscreen = true;
          }
          frame.replaceChildren(embed);
          previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          dialog.showModal();
        });
        root.querySelector('[data-app-video-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) {
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }
        });
        dialog.addEventListener('close', () => {
          frame.replaceChildren();
          document.body.style.overflow = previousOverflow;
          trigger.focus({ preventScroll: true });
        });
      });
    };
    initialise(document);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-app-remote-control"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.rrRemoteReady === 'true') return;
      root.dataset.rrRemoteReady = 'true';
      const tabs = [...root.querySelectorAll('[data-rr-remote-tab]')];
      const panels = [...root.querySelectorAll('[data-rr-remote-panel]')];
      const activate = (index, focusTab = false) => {
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && focusTab) tab.focus();
        });
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.querySelectorAll('video').forEach((video) => {
            if (active && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(() => {});
            if (!active) video.pause();
          });
        });
      };
      const currentIndex = () => Math.max(0, tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== index) { event.preventDefault(); activate(next, true); }
        });
      });
      root.querySelector('[data-rr-remote-direction="previous"]')?.addEventListener('click', () => activate((currentIndex() - 1 + tabs.length) % tabs.length));
      root.querySelector('[data-rr-remote-direction="next"]')?.addEventListener('click', () => activate((currentIndex() + 1) % tabs.length));
      activate(currentIndex());
    };
    document.querySelectorAll('[data-rr-remote]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-rr-remote]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-family-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (scope) => scope.querySelectorAll('.rr-family-products').forEach((root) => {
      if (root.dataset.productsInitialised) return;
      const rail = root.querySelector('[data-family-rail]');
      if (!rail) return;
      root.dataset.productsInitialised = 'true';
      const arrows = root.querySelector('.rr-family-products__arrows');
      if (rail.children.length < 2 && arrows) arrows.hidden = true;
      const move = (direction) => rail.scrollBy({left: direction * ((rail.firstElementChild?.getBoundingClientRect().width || 420) + 18), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      root.querySelector('[data-family-prev]')?.addEventListener('click', () => move(-1));
      root.querySelector('[data-family-next]')?.addEventListener('click', () => move(1));
    });
    initialise(document);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rr-hero-slider')) {
    customElements.define('rr-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const on = (target, event, fn, options = {}) => target.addEventListener(event, fn, { ...options, signal: this.abort.signal });
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-go]')];
        this.index = 0;
        this.progress?.cancel();
        this.progress = null;
        this.visible = false;
        this.editorPaused = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplay = this.dataset.autoplay === 'true' && !this.motion.matches;
        if (this.slides.length < 2) return;
        this.querySelector('.rr-hero__controls').hidden = false;
        on(this.querySelector('[data-prev]'), 'click', () => this.show(this.index - 1, true));
        on(this.querySelector('[data-next]'), 'click', () => this.show(this.index + 1, true));
        this.dots.forEach((dot, index) => on(dot, 'click', () => this.show(index, true)));
        on(document, 'visibilitychange', () => this.schedule());
        on(this.motion, 'change', event => { this.autoplay = this.dataset.autoplay === 'true' && !event.matches; this.show(this.index); });
        on(this, 'keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        });
        const viewport = this.querySelector('.rr-hero__viewport');
        on(viewport, 'pointerdown', event => {
          this.swiped = false;
          this.start = event.isPrimary && event.pointerType !== 'mouse' ? { x: event.clientX, y: event.clientY } : null;
        }, { passive: true });
        on(viewport, 'pointerup', event => {
          if (!this.start) return;
          const dx = event.clientX - this.start.x;
          const dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
            this.swiped = true;
            this.show(this.index + (dx < 0 ? 1 : -1), true);
          }
        }, { passive: true });
        on(viewport, 'pointercancel', () => { this.start = null; });
        on(viewport, 'click', event => { if (this.swiped) { event.preventDefault(); event.stopPropagation(); this.swiped = false; } }, { capture: true });
        on(document, 'shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
          if (index >= 0) { this.editorPaused = true; this.show(index); }
        });
        on(document, 'shopify:block:deselect', event => {
          if (this.contains(event.target)) { this.editorPaused = false; this.schedule(); }
        });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.slides[this.index].querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
          this.schedule();
        }, { threshold: .15 });
        this.observer.observe(this);
        this.show(0);
      }
      show(index, manual = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
          if (active && (this.visible || manual)) slide.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
          if (active) this.dots[i].setAttribute('aria-current', 'true');
          else this.dots[i].removeAttribute('aria-current');
        });
        if (manual) this.querySelector('[data-status]').textContent = this.slides[this.index].getAttribute('aria-label');
        this.progress?.cancel();
        this.progress = null;
        if (this.autoplay) {
          const fill = this.dots[this.index].querySelector('.rr-hero__fill');
          const animation = fill.animate([{ transform:'scaleX(0)' }, { transform:'scaleX(1)' }], { duration:Number(this.dataset.interval) || 6000, easing:'linear', fill:'forwards' });
          animation.pause();
          animation.onfinish = () => { if (this.progress === animation) this.show(this.index + 1); };
          this.progress = animation;
        }
        this.schedule();
      }
      schedule() {
        if (!this.progress) return;
        if (this.autoplay && this.visible && !document.hidden && !this.editorPaused) this.progress.play();
        else this.progress.pause();
      }
      disconnectedCallback() { this.progress?.cancel(); this.abort?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-product-support"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rr-product-support')) {
  customElements.define('rr-product-support', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const root = this;
      const $ = selector => selector.startsWith('#') ? root.querySelector('[data-rrps="' + selector.slice(1) + '"]') : root.querySelector(selector);
      const config = JSON.parse(root.querySelector('[data-rrps-config]').textContent);
      const strings = config.strings;
      const tr = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('__' + name.toUpperCase() + '__', value), strings[key] || key);
      const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      const icon = type => '<svg aria-hidden="true"><use href="#rrps-icon-' + type + '-' + root.dataset.sectionId + '"></use></svg>';
      const key = name => name.replaceAll('+', ' plus ').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      const normalize = name => name.replaceAll('+', ' plus ').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      const families = config.groups;
      const seen = new Set();
      const models = families.flatMap(group => group.models.map(name => name.trim()).filter(Boolean).flatMap(name => {
        const id = key(name);
        if (seen.has(id)) return [];
        seen.add(id);
        return [{id, name, family:group.id, familyLabel:group.label, icon:group.icon}];
      }));
      let selected = null, activeTab = 'all';
      let entries = [];
      const dialog = $('#info-dialog');
      let opener = null, oldOverflow = null;
      const listen = (element, event, callback) => element?.addEventListener(event, callback, {signal});
      root.querySelectorAll('[data-icon]').forEach(el => el.innerHTML = icon(el.dataset.icon));
      function closeDialog() { if (dialog.open) dialog.close(); }
      function showDialog(title, content, button) {
        opener = button || document.activeElement;
        const body = $('#dialog-body');
        body.replaceChildren();
        const heading = document.createElement('h2');
        heading.id = 'rrps-dialog-title-' + root.dataset.sectionId;
        heading.className = 'dialog-title';
        heading.textContent = title;
        body.append(heading, content);
        dialog.setAttribute('aria-labelledby', heading.id);
        oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
      }
      listen($('#dialog-close'), 'click', closeDialog);
      listen(dialog, 'close', () => {
        $('#dialog-body').querySelectorAll('video').forEach(video => video.pause());
        $('#dialog-body').replaceChildren();
        if (oldOverflow !== null) document.body.style.overflow = oldOverflow;
        oldOverflow = null;
        if (opener?.isConnected) opener.focus({preventScroll:true});
      });
      listen(dialog, 'click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog();
      });
      listen($('#identify'), 'click', event => {
        const content = document.createElement('div');
        content.className = 'dialog-text';
        const p = document.createElement('p'), help = document.createElement('p'), actions = document.createElement('div'), link = document.createElement('a');
        p.textContent = strings.identify_text; help.textContent = strings.identify_help; actions.className = 'dialog-buttons';
        link.className = 'button dark'; link.href = config.contact; link.textContent = strings.identify_contact + ' ↗'; actions.append(link); content.append(p,help,actions);
        showDialog(strings.identify_heading,content,event.currentTarget);
      });
      const pickers = [...root.querySelectorAll('[data-model-picker]')];
      const pickerDialog = $('#picker-dialog'), pickerPanel = $('#picker-panel');
      const mobilePicker = matchMedia('(max-width: 599px)');
      let pickerOverflow = null, restorePickerFocus = true;
      function syncPickers() {
        pickers.forEach(picker => {
          const active = selected?.family === picker.dataset.category;
          picker.value = active ? selected.id : '';
          picker.closest('[data-picker-category]').classList.toggle('is-active', active);
        });
        $('#mobile-model-name').textContent = selected?.name || strings.choose_model;
        $('#open-picker').setAttribute('aria-label', selected ? strings.change_model + ': ' + selected.name : strings.choose_model);
      }
      function closePicker(restore = true) {restorePickerFocus = restore; if(pickerDialog.open) pickerDialog.close();}
      function openPicker(family = selected?.family) {
        if(!mobilePicker.matches) return;
        restorePickerFocus = true;
        if(!pickerDialog.open){pickerOverflow = document.body.style.overflow;document.body.style.overflow = 'hidden';pickerDialog.showModal();}
        $('#open-picker').setAttribute('aria-expanded','true');
        (pickers.find(picker => picker.dataset.category === family) || pickers[0])?.focus({preventScroll:true});
      }
      function mountPickers() {
        const wasOpen = pickerDialog.open;
        if(!mobilePicker.matches) closePicker(false);
        (mobilePicker.matches ? $('#picker-dialog-body') : $('#picker-home')).append(pickerPanel);
        if(wasOpen && !mobilePicker.matches) (pickers.find(picker => picker.dataset.category === selected?.family) || pickers[0])?.focus({preventScroll:true});
      }
      listen(mobilePicker,'change',mountPickers);
      listen($('#open-picker'),'click',() => openPicker());
      listen($('#close-picker'),'click',() => closePicker());
      listen(pickerDialog,'close',() => {
        if(pickerOverflow!==null) document.body.style.overflow = pickerOverflow;
        pickerOverflow = null;
        $('#open-picker').setAttribute('aria-expanded','false');
        if(restorePickerFocus && mobilePicker.matches) $('#open-picker').focus({preventScroll:true});
      });
      listen(pickerDialog,'click',event => {
        if(event.target!==pickerDialog)return;
        const rect=pickerDialog.getBoundingClientRect();
        if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom) closePicker();
      });
      pickers.forEach(picker => listen(picker,'change',() => {
        if(!picker.value)return;
        const fromDialog=pickerDialog.open;
        if(fromDialog)closePicker(false);
        selectModel(picker.value,fromDialog);
      }));
      mountPickers();
      function renderTabs() {
        const modelEntries = selected ? matchingEntries() : [];
        const counts = {
          all: modelEntries.length,
          start: modelEntries.filter(entry => entry.topic === 'start').length,
          care: modelEntries.filter(entry => entry.topic === 'care').length,
          manual: modelEntries.filter(entry => entry.topic === 'manual').length
        };
        const labels = {all:strings.all_resources,start:strings.start,care:strings.care,manual:strings.manual};
        root.querySelectorAll('[data-tab]').forEach(button => {
          const count = document.createElement('span');
          count.className = 'tab-count'; count.textContent = counts[button.dataset.tab]; count.setAttribute('aria-hidden','true');
          button.replaceChildren(document.createTextNode(labels[button.dataset.tab]),count);
          button.setAttribute('aria-label', labels[button.dataset.tab] + ', ' + counts[button.dataset.tab]);
          const active = button.dataset.tab === activeTab;
          button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1;
        });
        $('#resource-panel').setAttribute('aria-labelledby', $('#tab-' + activeTab).id);
      }
      function matchingEntries() { return entries.filter(entry => entry.models.some(name => key(name) === selected.id)); }
      function emptyState() {
        const element = document.createElement('div'); element.className = 'empty-resources';
        const heading = document.createElement('h3'), description = document.createElement('p'), actions = document.createElement('div');
        heading.textContent = strings[{all:'empty_title',start:'empty_start',care:'empty_care',manual:'empty_manual'}[activeTab]];
        description.textContent = strings.empty_text; actions.className = 'empty-actions';
        const manualEntry = matchingEntries().find(entry => entry.topic === 'manual');
        if (manualEntry && ['start','care'].includes(activeTab)) {
          const source = manualEntry.template.content.querySelector('.manual-link');
          if (source) {
            const manualLink = document.createElement('a');
            manualLink.className = 'button dark'; manualLink.href = source.href; manualLink.target = '_blank'; manualLink.rel = 'noopener noreferrer'; manualLink.textContent = strings.view_manual + ' ↗';
            actions.append(manualLink);
          }
        }
        const supportLink = document.createElement('a');
        supportLink.className = actions.childElementCount ? 'text-button' : 'button dark'; supportLink.href = config.contact; supportLink.textContent = strings.contact + ' ↗'; actions.append(supportLink);
        element.innerHTML = icon(activeTab === 'manual' ? 'manual' : 'play'); element.append(heading,description,actions); return element;
      }
      function renderResources() {
        const target = $('#resource-content'); target.replaceChildren();
        if (!selected) return;
        const list = matchingEntries().filter(entry => activeTab === 'all' || entry.topic === activeTab);
        if (!list.length) { target.append(emptyState()); return; }
        for (const topic of ['start','care','manual']) {
          const resources = list.filter(entry => entry.topic === topic); if (!resources.length) continue;
          const group = document.createElement('section'); group.className = 'resource-group';
          const header = document.createElement('div'); header.className = 'group-heading';
          const title = document.createElement('h3'), type = document.createElement('span');
          title.textContent = strings[{start:'start',care:'care_heading',manual:'manual'}[topic]];
          type.textContent = strings[topic === 'manual' ? 'pdf' : 'video_guides']; header.append(title,type); group.append(header);
          const grid = document.createElement('div'); if (topic !== 'manual') grid.className = 'video-grid';
          resources.forEach(entry => grid.append(entry.template.content.cloneNode(true))); group.append(grid); target.append(group);
        }
      }
      function collectEntries() {
        entries = [...document.querySelectorAll('[data-rrps-entry]')].map(template => ({template, models:template.dataset.models.split(/\r?\n/).map(name=>name.trim()).filter(Boolean),topic:template.dataset.topic,blockId:template.dataset.blockId,title:template.dataset.title}));
        if (selected) renderTabs();
        renderResources();
      }
      function selectModel(id, scroll = false) {
        const model = models.find(item => item.id === id); if (!model) return;
        selected = model; activeTab = 'all';
        $('#model-title').textContent = tr('support_for',{model:model.name});
        $('#selected-name').textContent = model.name; $('#selected-family').textContent = model.familyLabel; $('#selected-icon').innerHTML = icon(model.icon);
        $('#resources').hidden = false; $('#how-it-works').hidden = true;
        syncPickers(); renderTabs(); renderResources();
        if (!window.Shopify?.designMode) {
          const url = new URL(location.href); url.searchParams.set('support_model', model.id); history.replaceState(null, '', url);
        }
        if (scroll) { $('#resources').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'}); $('#resources-heading').focus({preventScroll:true}); }
      }
      listen($('#change-model'), 'click', () => {
        if(mobilePicker.matches){openPicker();return;}
        $('#find-model').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        pickers.find(picker=>picker.dataset.category===selected.family)?.focus({preventScroll:true});
      });
      listen($('.resource-tabs'), 'click', event => { const button = event.target.closest('[data-tab]'); if (button) { activeTab = button.dataset.tab; renderTabs(); renderResources(); } });
      listen($('.resource-tabs'), 'keydown', event => {
        if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return; event.preventDefault();
        const tabs = [...root.querySelectorAll('[data-tab]')]; let index = tabs.indexOf(document.activeElement);
        index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[index].click(); tabs[index].focus();
      });
      listen($('#resource-content'), 'click', event => {
        const button = event.target.closest('[data-rrps-video]'); if (!button) return;
        const template = document.getElementById(button.dataset.rrpsVideo); if (!template) return;
        const content = document.createElement('div'); content.className = 'player-content'; content.append(template.content.cloneNode(true));
        showDialog(button.dataset.title,content,button);
      });
      listen(document, 'shopify:section:load', collectEntries);
      listen(document, 'shopify:section:unload', event => {
        const section = event.target;
        entries = entries.filter(entry => !section.contains(entry.template)); renderResources();
      });
      listen(document, 'shopify:block:select', event => {
        const entry = entries.find(item => item.blockId === event.detail.blockId);
        if (entry) { const model = models.find(item => entry.models.includes(item.name)); if (model) {selectModel(model.id); activeTab = entry.topic; renderTabs(); renderResources(); $('#resources').scrollIntoView({block:'start'});} }
        else if (families.some(group => group.id === event.detail.blockId)) {if(mobilePicker.matches)openPicker(event.detail.blockId);else{$('#find-model').scrollIntoView({block:'start'});pickers.find(picker=>picker.dataset.category===event.detail.blockId)?.focus({preventScroll:true});}}
      });
      const start = () => {
        collectEntries(); syncPickers();
        const url = new URL(location.href); const id = url.searchParams.get('support_model'); if (id) selectModel(id);
        root.dataset.ready = 'true';
      };
      if (document.readyState === 'loading') listen(document, 'DOMContentLoaded', start); else start();
      this.cleanup = () => {if(dialog.open)closeDialog(); closePicker(false); if(oldOverflow!==null)document.body.style.overflow=oldOverflow; if(pickerOverflow!==null)document.body.style.overflow=pickerOverflow;};
    }
    disconnectedCallback() {this.cleanup?.(); this.controller?.abort(); this.initialized = false;}
  });
}


  } catch(e) { console.error(e); }
})();
})();
